import { LocationPage } from "apps/oneOnboarding/location/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(LocationPage, "LocationPage");
